export default __webpack_public_path__ + "static/media/postgressql.250b462f.png";